import _ from "lodash";
import * as Tag from "@/helper/characteristic/Tag";

export function isEligible (employmentModes)
{
	if (!employmentModes)
	{
		return false;
	}

	return _
		.filter(
			employmentModes,
			characteristic => Tag.hasTag(characteristic, Tag.CAREER_LEVEL_ELIGIBLE)
		)
		.length > 0;
}
